import React, { useState, useEffect } from 'react';
import { FORM_MODE } from '@awp/constants';
import { getUtcToLocal } from '@awp/helpers/utilsReact';
import { Row, Col } from 'react-bootstrap';
import { FormRichTextEditor } from '@awp/components/Common/AwpFormInputs';
import Authorize from '@awp/components/Authorize';
import { Permissions } from '@awp/constants';

const SystemNotificationCard = ({ data, setMode, setNotificationMessageData, setShowYesNoModal }) => {
  const [expanded, setExpanded] = useState(true);

  const toggleExpand = () => {
    setExpanded(!expanded);
  };

  useEffect(() => {
    setExpanded(!expanded);
  }, [data]);

  const notificationClass = (isUrgent) => {
    return isUrgent
      ? 'fas fa-exclamation-circle mx-1 my-1 mr-3 awp-img-btn float-left system-notification-warning-icon'
      : 'fas fa-bell mx-1 my-1 mr-3 awp-img-btn float-left system-notification-icon';
  };

  const cardContentShowLabel = !expanded ? 'Show More' : 'Show Less';

  return (
    <div
      className="card mb-3 system-notification"
      style={{ backgroundColor: data.IsUrgent == 'Y' ? '#FFF1D5' : '#F7F9FD' }}
    >
      <div
        className="card-header system-notification"
        style={{ backgroundColor: data.IsUrgent == 'Y' ? '#FFF1D5' : '#F7F9FD' }}
      >
        <Row>
          <Col xs={8} sm={10}>
            <i className={notificationClass(data.IsUrgent == 'Y')}></i>
            <h4>{data.Name}</h4>
          </Col>
          <Authorize requires={[Permissions.WriteSysNotification]}>
            <Col xs={4} sm={2}>
              <i
                className="fas fa-edit mx-1 my-1 awp-img-btn float-right"
                title="Edit"
                onClick={() => {
                  setNotificationMessageData(data);
                  setMode(FORM_MODE.EDIT);
                }}
              ></i>
              <i
                className="fas fa-trash mx-1 my-1 awp-img-btn float-right"
                title="Delete"
                onClick={() => {
                  setNotificationMessageData(data);
                  setShowYesNoModal(true);
                }}
              ></i>
            </Col>
          </Authorize>
        </Row>
        <Row>
          <Col sm={1}></Col>
          <Col sm={9}>
            <span style={{ fontSize: '12px' }}>
              Created {getUtcToLocal(data.AppCreatetimestamp)} by <strong>{data.UserFirstNameCreated}</strong>
            </span>
          </Col>
        </Row>
        {data.AppCreatetimestamp != data.AppLastUpdatetimestamp ? (
          <Row>
            <Col sm={1}></Col>
            <Col sm={9}>
              <span style={{ fontSize: '12px' }}>
                Last Updated {getUtcToLocal(data.AppLastUpdatetimestamp)} by{' '}
                <strong>{data.UserFirstNameUpdated}</strong>
              </span>
            </Col>
          </Row>
        ) : (
          <></>
        )}
        {data.Expirytimestamp ? (
          <Row>
            <Col sm={1}></Col>
            <Col sm={9}>
              <span style={{ fontSize: '12px' }}>Expires {getUtcToLocal(data.Expirytimestamp)}</span>
            </Col>
          </Row>
        ) : (
          <></>
        )}
        {(JSON.parse(data?.Content)?.tag ?? '')?.length > 0 ? (
          <Row>
            <Col sm={1}></Col>
            <Col sm={11}>
              <span className="tag-cloud" style={{ fontSize: '12px' }}>
                {JSON.parse(data?.Content)?.tag ?? ''}
              </span>
            </Col>
          </Row>
        ) : (
          <></>
        )}
      </div>
      <div className="card-body system-notification" style={{ paddingTop: '0px', paddingBottom: '0px' }}>
        <Row>
          <Col sm={1}></Col>
          <Col sm={11}>
            <FormRichTextEditor content={JSON.parse(data?.Content)?.editor ?? ''} mode={'VIEW'} isExpanded={expanded} />
          </Col>
        </Row>
      </div>
      {JSON.parse(data.Content)?.text?.length > 200 ? (
        <div
          className="card-footer system-notification"
          style={{ backgroundColor: data.IsUrgent == 'Y' ? '#FFF1D5' : '#F7F9FD', paddingTop: '0px' }}
        >
          <div className="d-flex justify-content-center">
            <span
              style={{ fontSize: '12px', color: '#003366', textDecorationLine: 'underline' }}
              onClick={toggleExpand}
            >
              {cardContentShowLabel}
            </span>
          </div>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default SystemNotificationCard;
